import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuHorizontalScrollingSection} from '@Components/contextual-menu/components/contextual-menu-horizontal-scrolling-section';
import {getTemplateStylesAndProperties} from '@PosterWhiteboard/items/transcript-item/subtitle/template-styles';
import type {BaseTemplateStyleThumbnailOptionsProps} from './template-style-thumbnail-options.types';
import styles from './template-style-thumbnail-options.module.scss';
import {GA4EventName, GA4EventParamName, trackPosterBuilderGA4Events} from '@Libraries/ga-events';
import {TemplateStyleThumbnail} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-transcript-options/components/template-style-thumbnail/template-style-thumbnail';

export function TemplateStyleThumbnailOptions({
  showScrollIcons = false,
  isLoading = false,
  isMobile = false,
  hideAnimationOptionsAndPresets = false,
  ...props
}: BaseTemplateStyleThumbnailOptionsProps): ReactElement {
  const prepareThumbnails = (): ReactElement[] => {
    const subtitleTemplatePresets: string[] = [];

    const sortedTemplates = Object.values(getTemplateStylesAndProperties(hideAnimationOptionsAndPresets)).sort(
      (a, b) => a.templateProperties.sortOrder - b.templateProperties.sortOrder
    );

    sortedTemplates.forEach((template) => {
      if (!template.templateProperties.isHidden) {
        subtitleTemplatePresets.push(template.templateProperties.id);
      }
    });

    return subtitleTemplatePresets.map((templateId) => {
      return (
        <TemplateStyleThumbnail
          isLoading={isLoading}
          isMobile={isMobile}
          isSelected={props.selectedTemplateId === templateId}
          id={templateId}
          onSelected={(): void => {
            trackPosterBuilderGA4Events(GA4EventName.AI_SUBTITLE_TEMPLATE_PRESET_SELECTED, {[GA4EventParamName.AI_SUBTITLE_TEMPLATE_ID]: templateId});
            props.updateCurrentTemplateStyle(templateId);
          }}
        />
      );
    });
  };

  return (
    <li className={`_full-width flex-center ${styles.templateStylesContainer}`}>
      <ContextualMenuHorizontalScrollingSection
        doSmoothAnimationOnScrollIconClick
        showScrollIcons={showScrollIcons}
        className={`spacing-p-l-5 spacing-p-r-5 flex-h-row spacing-m-0 ${styles.scrollingSectionGap}`}
      >
        {prepareThumbnails()}
      </ContextualMenuHorizontalScrollingSection>
    </li>
  );
}
